module.exports = __webpack_public_path__ + "static/media/wij-water-interreg-vn-eu-vertical.f26b996a.jpg";